(function () {
  'use strict';

  window.PGSocialProofDataV1 = {
    generatedAt: '2026-08-28T21:10:00Z',
    sourceWindowDays: 30,
    minimumPopularityCount: 3,
    recent: [
      {
        orderedAt: '2026-08-28T10:30:46Z',
        label: 'The Princess',
        city: 'Witham',
        handle: 'the-princess-custom-pet-canvas',
        image: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/the-princess-custom-pet-canvas-469351.jpg?v=1736870136'
      },
      {
        orderedAt: '2026-08-27T06:44:13Z',
        label: 'The Thug',
        city: 'Felmersham',
        handle: 'the-thug-peaky-blinders-inspired-custom-pet-portrait',
        image: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/the-thug-peaky-blinders-inspired-custom-pet-portrait-571513.jpg?v=1756960527'
      },
      {
        orderedAt: '2026-08-24T18:44:34Z',
        label: 'The General',
        city: 'Stamford',
        handle: 'the-general-custom-pet-poster',
        image: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/the-general-custom-pet-poster-789725.jpg?v=1721115352'
      },
      {
        orderedAt: '2026-08-24T16:00:58Z',
        label: 'The Duke',
        city: 'Gaithersburg',
        handle: 'the-duke-custom-pet-portrait',
        image: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/IMG-2009.webp?v=1782453574'
      },
      {
        orderedAt: '2026-08-23T12:26:53Z',
        label: 'The Pearl Princess',
        city: 'London',
        handle: 'the-pearl-princess-custom-pet-canvas',
        image: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/the-pearl-princess-custom-pet-canvas-433652.jpg?v=1736870156'
      },
      {
        orderedAt: '2026-08-22T09:07:04Z',
        label: 'The Pearl Princess',
        city: 'Liverpool',
        handle: 'the-pearl-princess-custom-pet-portrait',
        image: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/the-pearl-princess-custom-pet-portrait-917916.jpg?v=1756962076'
      },
      {
        orderedAt: '2026-08-21T20:41:57Z',
        label: 'The Golden King',
        city: 'Manchester',
        handle: 'the-golden-king-custom-pet-portrait',
        image: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/the-golden-king-custom-pet-portrait-559997.jpg?v=1756955687'
      },
      {
        orderedAt: '2026-08-21T12:26:00Z',
        label: 'The Dignitary',
        city: 'Chelmsford',
        handle: 'the-dignitary-custom-pet-portrait',
        image: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/the-dignitary-custom-pet-portrait-967663.jpg?v=1721141909'
      },
      {
        orderedAt: '2026-08-21T09:13:41Z',
        label: 'The Colonel',
        city: 'Woking',
        handle: 'the-colonel-custom-pet-portrait',
        image: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/the-colonel-custom-pet-portrait-643900.jpg?v=1756955279'
      },
      {
        orderedAt: '2026-08-19T11:53:23Z',
        label: 'The Colonel',
        city: 'Macclesfield',
        handle: 'the-colonel-custom-pet-portrait',
        image: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/the-colonel-custom-pet-portrait-643900.jpg?v=1756955279'
      },
      {
        orderedAt: '2026-08-18T19:18:34Z',
        label: '1920s Gangster',
        city: 'Grantham',
        handle: 'tommy-peaky-blinders-inspired-custom-pet-portrait',
        image: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/tommy-peaky-blinders-inspired-custom-pet-portrait-525227.jpg?v=1721118559'
      },
      {
        orderedAt: '2026-08-18T17:42:36Z',
        label: 'Armoured Comic Hero',
        city: 'Santa Monica',
        handle: 'iron-paw-custom-pet-portrait',
        image: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/iron-paw-custom-pet-portrait-507368.jpg?v=1721100220'
      }
    ],
    popularitySales: [
      { productId: '6119401783489', orderedAt: '2026-08-08T19:48:51Z', quantity: 1 },
      { productId: '6119401783489', orderedAt: '2026-08-07T07:57:06Z', quantity: 1 },
      { productId: '6119401783489', orderedAt: '2026-08-05T10:16:30Z', quantity: 1 },
      { productId: '6119401783489', orderedAt: '2026-08-03T09:00:05Z', quantity: 1 },
      { productId: '6119401783489', orderedAt: '2026-08-02T18:45:52Z', quantity: 1 },

      { productId: '6624553500865', orderedAt: '2026-08-24T16:00:58Z', quantity: 1 },
      { productId: '6624553500865', orderedAt: '2026-08-14T05:42:05Z', quantity: 1 },
      { productId: '6624553500865', orderedAt: '2026-07-30T14:15:55Z', quantity: 1 },

      { productId: '6732935823553', orderedAt: '2026-08-17T21:13:40Z', quantity: 1 },
      { productId: '6732935823553', orderedAt: '2026-08-17T12:22:08Z', quantity: 1 },
      { productId: '6732935823553', orderedAt: '2026-08-16T15:17:48Z', quantity: 1 },

      { productId: '6119534133441', orderedAt: '2026-08-21T09:13:41Z', quantity: 1 },
      { productId: '6119534133441', orderedAt: '2026-08-19T11:53:23Z', quantity: 2 }
    ],
    popularityCopy: {
      '6119401783489': 'Apparently, military promotion is popular {period}.',
      '6119534133441': 'Apparently, military promotion is popular {period}.',
      '6624553500865': 'Apparently, aristocratic ambition is popular {period}.',
      '6732935823553': 'Apparently, aristocratic ambition is popular {period}.'
    }
  };
})();
